import { render, staticRenderFns } from "./AuctionClarifications.vue?vue&type=template&id=31a6907a&scoped=true&"
import script from "./AuctionClarifications.vue?vue&type=script&lang=js&"
export * from "./AuctionClarifications.vue?vue&type=script&lang=js&"
import style0 from "./AuctionClarifications.vue?vue&type=style&index=0&id=31a6907a&lang=scss&scoped=true&"
import style1 from "@/styles/manifestacao.scss?vue&type=style&index=1&id=31a6907a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a6907a",
  null
  
)

export default component.exports